// CANONICAL COPY (GH #7115). src/constants/obligations/obl-employment-terms.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-employment-terms',
  title: 'Verify employment agreements include IS responsibilities',
  description:
    "Confirm that employment contracts state personnel's IS responsibilities. Check joiner JML checklists for contract-signed.",
  category: 'people',
  scfIds: ['SCF-PPL-002'],
  cadence: { frequency: '6m', anchor: 'domain' },
  strategy: 'any',
  fulfilmentCriteria: [
    {
      type: 'jml-process-complete',
      jmlType: 'join',
      description: 'All joiner processes are completed (including contract signing)',
    },
    { type: 'document-published', description: 'Employment terms policy is published' },
  ],
  domainActions: [
    { type: 'approve-document', label: 'Approve Document' },
    { type: 'deep-link', target: 'employees', label: 'Review Employee Records' },
  ],
};
